/*
 * store.js
 *
 * Description: Holds common/global Stores.
 *
 * This file is part of: "http://apps.sundair.com/", "SunCrew2"
 * Copyright 2018,2019,2020 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import Vue from 'vue';
import Vuex from 'vuex';
import people from './modules/people/people'; // 'Store::People'
import crews from './modules/crews/crews'; // 'Store::Crews'
import shared from './modules/shared/shared'; // 'Store::Shared'

import * as getters from './getters'; // global ones
import * as mutations from './mutations';
import * as actions from './actions';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        value: 0 // >>> just demo
    },
    getters,
    mutations,
    actions,
    modules: {
        people,
        crews,
        shared,
    }
});
